export function formatDateTime(value: string) {
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

export function formatDate(value: string) {
  return new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(new Date(value));
}

export function formatRelativeTime(value: string) {
  const deltaSeconds = Math.round((new Date(value).getTime() - Date.now()) / 1000);
  const absSeconds = Math.abs(deltaSeconds);
  const formatter = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });

  if (absSeconds < 60) return "now";
  if (absSeconds < 3600) return formatter.format(Math.round(deltaSeconds / 60), "minute");
  if (absSeconds < 86_400) return formatter.format(Math.round(deltaSeconds / 3600), "hour");
  if (absSeconds < 2_592_000) return formatter.format(Math.round(deltaSeconds / 86_400), "day");
  if (absSeconds < 31_536_000) return formatter.format(Math.round(deltaSeconds / 2_592_000), "month");

  return formatter.format(Math.round(deltaSeconds / 31_536_000), "year");
}

export function hostFromUrl(value: string) {
  try {
    return new URL(value).host;
  } catch {
    return value;
  }
}

export function visitableHttpUrl(value: string) {
  try {
    const url = new URL(value);
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return null;
    }

    return value;
  } catch {
    return null;
  }
}

export function humanize(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function titleize(value: string) {
  return value
    .split("_")
    .map((word) => humanize(word))
    .join(" ");
}

export function formatDuration(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
}

export function formatScanRemaining(remainingSeconds: number) {
  if (remainingSeconds <= 30) {
    return "About 30 seconds left";
  }

  const minutes = Math.ceil(remainingSeconds / 60);
  return `About ${minutes} ${minutes === 1 ? "minute" : "minutes"} left`;
}

export function clampPercentage(value: number) {
  return Math.min(Math.max(value, 0), 100);
}

export function evaluatedCoverageScope(pageCount: number, journeyCount: number) {
  const parts: string[] = [];
  if (pageCount > 0) {
    parts.push(`${pageCount} ${pageCount === 1 ? "page" : "pages"}`);
  }
  if (journeyCount > 0) {
    parts.push(`${journeyCount} ${journeyCount === 1 ? "journey" : "journeys"}`);
  }
  if (parts.length === 0) return null;
  if (parts.length === 1) return parts[0];
  return `${parts[0]} and ${parts[1]}`;
}
